export default __webpack_public_path__ + "static/media/030-sunsets.266c60a4.svg";